import Header from './Header';
import Slideshow from './Slideshow';
import Experience from './Experience';
import Contact from './Contact';
import Footer from './Footer';
import Box from './Box';
import ModalCupos from './ModalCupos';

const Landing = () => {

  return (
    
    <Box>
      <Header />
      <Slideshow />
      <Experience />
      <Contact />
      <Footer />
      <ModalCupos />
    </Box>
  )
}

export default Landing;
